<template>
    <div class="width100">
        <vue-confirm-dialog></vue-confirm-dialog>
        <b-modal id="modalInfo" hide-footer
                 header-bg-variant="thtab"
                 header-text-variant="light">
            <template v-slot:modal-title>

            </template>
            <div class="d-block">
                <div v-if="errors.length" class="alert alert-danger text-center" role="alert">
                    <p v-for="(error, key) in errors" :key="key">{{ error }}</p>
                </div>
                <div v-if="msgs.length" class="alert alert-success text-center" role="alert">
                    <p v-for="(msg, key) in msgs" :key="key">{{ msg }}</p>
                </div>
            </div>
        </b-modal>

        <Aide v-bind:token="token" v-bind:site="site" v-bind:racine="racine"
              v-bind:user="user" v-bind:idAide="8"></Aide>

        <h3 class="titreSolu text-center">Gestion utilisateurs</h3>
        <b-collapse id="collapse-2">
            <h4 class="text-center">Créer un type</h4>
            <div>
                <div class="row" style="margin-top: 75px;">
                    <div class="col-1">
                    </div>
                    <div class="col-3">
                        Initiales
                    </div>
                    <div class="col-7">
                        <input type="text" class="form-control" v-model="nameUser" name="nameUser"
                               placeholder="initiales">
                    </div>
                </div>
                <br/>
                <div class="row">
                    <div class="col-1">
                    </div>
                    <div class="col-3">
                        Roles
                    </div>
                    <div class="col-7">
                        <select v-model="rolesUser" class="form-control" name="rolesUser">
                            <option v-for="(lUser, key) in listRoles" :key="key"
                                    v-bind:value="key">{{ lUser }}
                            </option>
                        </select>
                    </div>
                </div>
                <br/>
                <div class="row">
                    <div class="col-1">
                    </div>
                    <div class="col-3">
                        Notification
                    </div>
                    <div class="col-7">
                        <select v-model="notifUser" class="form-control" name="rolesUser">
                            <option v-for="(lNot, key) in listNotif" :key="key"
                                    v-bind:value="key">{{ lNot }}
                            </option>
                        </select>
                    </div>
                </div>
                <br/>
                <div class="row">
                    <div class="col-1">
                    </div>
                    <div class="col-3">
                        Email
                    </div>
                    <div class="col-7">
                        <input type="text" class="form-control" v-model="emailUser" name="emailUser"
                               placeholder="Email">
                    </div>
                </div>
                <br/>
                <div class="row">
                    <div class="col-1">
                    </div>
                    <div class="col-3">
                        Mot de passe
                    </div>
                    <div class="col-7">
                        <input type="text" class="form-control" v-model="pwdUser" name="pwdUser"
                               placeholder="Mot de passe">
                    </div>
                </div>
                <br/>
                <div class="row">
                    <div class="col-1">
                    </div>
                    <div class="col-3">
                        Téléphone
                    </div>
                    <div class="col-7">
                        <input type="text" class="form-control" v-model="telephoneUser" name="telephoneUser"
                               placeholder="0123456789">
                    </div>
                </div>
                <br/>
                <div class="row">
                    <div class="col-1">
                    </div>
                    <div class="col-3">
                        Système
                    </div>
                    <div class="col-7">
                        <select v-model="scUser" class="form-control" name="scUser">
                            <option v-for="(system, key) in listSC" :key="key"
                                    v-bind:value="system['@id']">{{ system.nom }}
                            </option>
                        </select>
                    </div>
                </div>
                <br/>
                <div class="row">
                    <div class="col-12 text-center">
                        <button class="btn btn-primary" block @click="addUser()">
                            Valider
                        </button>
                    </div>
                </div>
            </div>
        </b-collapse>
        <div v-if="errors.length" class="alert alert-danger text-center" role="alert">
            <p v-for="(error, key) in errors" :key="key">{{ error }}</p>
        </div>
        <div v-if="msgs.length" class="alert alert-success text-center" role="alert">
            <p v-for="(msg, key) in msgs" :key="key">{{ msg }}</p>
        </div>

        <div>
            <h4 class="text-center">Liste des utilisateurs</h4>
            <div class="row">
                <div class="col-12 text-right">
                    <button v-b-toggle="'collapse-2'" class="btn btn-primary"><i class="fa-solid fa-plus"></i> Ajout
                        utilisateur
                    </button>
                </div>
            </div>
            <table v-if="listUser.length>0" class="table table-striped table-bordered ">
                <tr>
                    <th class="thtab">Initiales</th>
                    <th class="thtab">Roles</th>
                    <th class="thtab">Notification</th>
                    <th class="thtab">Email</th>
                    <th class="thtab">MDP</th>
                    <th class="thtab">Téléphone</th>
                    <th class="thtab">Système</th>
                    <th class="thtab"></th>
                    <th class="thtab"></th>
                </tr>
                <tr v-for="(user, key) in listUser" :key="key">
                    <td>
                        <span v-if="keyUpd!=key">{{user.name}}</span>
                        <input v-if="keyUpd==key" type="text" v-model="nameUserUpd" class="form-control">
                    </td>
                    <td>
                        <span v-if="keyUpd!=key">
                            {{getRolesAU(user.roles)}}
                        </span>
                        <select v-if="keyUpd==key" v-model="rolesUserUpd" class="form-control" name="rolesUserUpd">
                            <option v-for="(lUser, key) in listRoles" :key="key"
                                    v-bind:value="key">{{ lUser }}
                            </option>
                        </select>
                    </td>
                    <td>
                        <span v-if="keyUpd!=key">
                                {{getRolesNotif(user.roles)}}
                        </span>
                        <select v-if="keyUpd==key" v-model="notifUserUpd" class="form-control" name="rolesUser">
                            <option v-for="(lNot, key) in listNotif" :key="key"
                                    v-bind:value="key">{{ lNot }}
                            </option>
                        </select>
                    </td>
                    <td>
                        <span v-if="keyUpd!=key">{{user.email}}</span>
                        <input v-if="keyUpd==key" type="text" v-model="emailUserUpd" class="form-control">
                    </td>
                    <td>
                        <span v-if="keyUpd!=key">****</span>
                        <input v-if="keyUpd==key" type="text" v-model="pwdUserUpd" class="form-control"
                               placeholder="Laissez vide, si pas besoin">
                    </td>
                    <td>
                        <span v-if="keyUpd!=key">{{user.telephone}}</span>
                        <input v-if="keyUpd==key" type="number" v-model="telephoneUserUpd" class="form-control"
                               placeholder="Laissez vide, si pas besoin">
                    </td>
                    <td>
                        <span v-if="keyUpd!=key && user.systemeClient != null">{{user.systemeClient.nom}}</span>
                        <select v-if="keyUpd==key" v-model="scUserUpd" class="form-control" name="scUser">
                            <option v-for="(system, key) in listSC" :key="key"
                                    v-bind:value="system['@id']">{{ system.nom }}
                            </option>
                        </select>
                    </td>
                    <td>
                        <i v-if="keyUpd!=key" class="fa-solid fa-pen-to-square fa-2x text-warning"
                           @click="beforeUpdate(key)"></i>
                        <i v-if="keyUpd==key" class="fa-solid fa-check fa-2x text-success"
                           @click="valideUpdate(key)"></i>
                        &nbsp;
                        <i v-if="keyUpd==key" class="fa-solid fa-xmark fa-2x text-danger" @click="cancel()"></i>
                    </td>
                    <td>
                        <i class="fa-regular fa-trash-can fa-2x text-danger" @click="deleteObjet(key)"></i>
                    </td>
                </tr>
            </table>
        </div>
        <div class="row">
            <div class="col-12 text-center text-info">
                {{listUser.length}} entité(s)
            </div>
        </div>
    </div>
</template>

<script>
    import Aide from './Aide';

    export default {
        name: "User",
        props: ['token', 'site', 'user', 'racine', 'userId', 'systemeClient', 'systemeClientId'],
        data() {
            return {
                typeMachine: 1,
                errors: [],
                msgs: [],
                listRoles: {1: 'user', 2: 'admin'},
                listNotif: {1: "Oui", 0: "Non"},
                listUser: [],
                keyUpd: null,
                checkValideMachin: true,
                listSC: [],
                nameUser: '',
                nameUserUpd: '',
                emailUser: '',
                emailUserUpd: '',
                rolesUser: 1,
                rolesUserUpd: 1,
                pwdUser: '',
                telephoneUser: '',
                telephoneUserUpd: '',
                pwdUserUpd: '',
                scUser: 1,
                scUserUpd: 1,
                notifUser: 1,
                notifUserUpd: 1,
                notifText: '',
                rolesText: '',
            };
        },
        methods:
            {
                getRolesAU(roles) {
                    var rolesR = 'user'
                    roles.forEach(function (role) {
                        if (role == 'admin') {
                            rolesR = 'admin'
                        }
                    })
                    return rolesR
                },
                getRolesNotif(roles) {
                    var rolesN = 'non'
                    roles.forEach(function (role) {
                        if (role == 'notif') {
                            rolesN = 'oui'
                        }
                    })
                    return rolesN
                },
                tokenValide(json) {
                    if (json['status'] == '401') {
                        this.$emit('token')
                    }
                },
                addUser() {
                    this.errors = [];
                    this.msgs = [];
                    if (this.nameUser != '') {
                        if (this.emailUser != '') {
                            if (this.scUser != '') {
                                console.log(this.nameUser)
                                console.log(this.emailUser)
                                console.log(this.rolesUser)
                                console.log(this.pwdUser)
                                console.log(this.scUser)
                                console.log(this.notifUser)

                                let rolesJSON = ""
                                if (this.notifUser == 1) {
                                    rolesJSON = '["' + this.listRoles[this.rolesUser] + '","notif"]'
                                }
                                else {
                                    rolesJSON = '["' + this.listRoles[this.rolesUser] + '"]'
                                }
                                console.log(rolesJSON)


                                fetch(this.racine + this.site + 'api/users', {
                                    method: 'POST',
                                    headers: {
                                        'Content-Type': 'application/json',
                                        'Authorization': 'Bearer ' + this.token
                                    },
                                    body: "{\"name\":\"" + this.nameUser + "\"," +
                                    "\"email\": \"" + this.emailUser + "\"," +
                                    "\"roles\": " + rolesJSON + "," +
                                    "\"password\": \"" + this.pwdUser + "\"," +
                                    "\"plainPassword\": \"" + this.pwdUser + "\"," +
                                    "\"telephone\": \"" + this.telephoneUser + "\"," +
                                    "\"systemeClient\": \"" + this.scUser + "\"" +
                                    "}"
                                }).then(response => response.json())
                                    .then(json => {
                                        console.log(json);
                                        if (json['@type'] == "hydra:Error") {
                                            this.errors.push("Cet email est déjà utilisé.")
                                            this.popup()
                                        }
                                        else if (json['id'] > 0) {
                                            this.msgs.push("Ajout du type effectué.")
                                            this.getUsers()
                                            this.nameUser = ''
                                            this.popup()
                                        }
                                        else {
                                            this.errors.push("Un problème inconnu s'est produit.")
                                            this.popup()
                                        }
                                    })
                            }
                            else {
                                this.errors.push("Vous devez sélectionner le système.");
                            }
                        }
                        else {
                            this.errors.push("Vous devez remplir l'e-mail.");
                        }
                    }
                    else {
                        this.errors.push("Vous devez remplir le nom.");
                    }


                },
                getUsers() {
                    fetch(this.racine + this.site + 'api/users', {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + this.token
                        },
                    }).then(response => {
                        this.tokenValide(response)
                        console.log(response)
                        response.json().then(json => {
                            if (json != undefined) {
                                console.log(json)
                                this.listUser = json['hydra:member']
                            }
                        })
                    })
                    fetch(this.racine + this.site + 'api/systeme_clients', {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + this.token
                        },
                    }).then(response => {
                        this.tokenValide(response)
                        console.log(response)
                        response.json().then(json => {
                            if (json != undefined) {
                                console.log(json)
                                this.listSC = json['hydra:member']
                            }
                        })
                    })
                },
                beforeUpdate(keyMachine) {
                    //on charge les données de la ligne dans les variables pour l'update
                    this.keyUpd = keyMachine
                    this.nameUserUpd = this.listUser[this.keyUpd].name
                    this.rolesUserUpd = this.listUser[this.keyUpd].roles
                    this.emailUserUpd = this.listUser[this.keyUpd].email
                    this.telephoneUserUpd = this.listUser[this.keyUpd].telephone
                    this.scUserUpd = this.listUser[this.keyUpd].systemeClient['@id']
                    var rolesN = 0
                    this.listUser[this.keyUpd].roles.forEach(function (role) {
                        if (role == 'notif') {
                            rolesN = 1
                        }
                    })
                    this.notifUserUpd = rolesN

                    var rolesUA = 1
                    this.listUser[this.keyUpd].roles.forEach(function (role) {
                        if (role == 'admin') {
                            rolesUA = 2
                        }
                    })
                    this.rolesUserUpd = rolesUA
                },
                valideUpdate(key) {
                    this.errors = [];
                    this.msgs = [];
                    let rolesJSON = ""
                    if (this.notifUserUpd == 1) {
                        rolesJSON = '["' + this.listRoles[this.rolesUserUpd] + '","notif"]'
                    }
                    else {
                        rolesJSON = '["' + this.listRoles[this.rolesUserUpd] + '"]'
                    }

                    //le body standard sans mdp
                    var bodyUpd = "{\"name\":\"" + this.nameUserUpd + "\"," +
                        "\"email\": \"" + this.emailUserUpd + "\"," +
                        "\"roles\": " + rolesJSON + "," +
                        "\"systemeClient\": \"" + this.scUserUpd + "\"," +
                        "\"telephone\": \"" + this.telephoneUserUpd + "\"" +
                        "}"

                    if (this.pwdUserUpd != '') {//si il y a un mdp, on le prend en compte
                        bodyUpd = "{\"name\":\"" + this.nameUserUpd + "\"," +
                            "\"email\": \"" + this.emailUserUpd + "\"," +
                            "\"roles\": " + rolesJSON + "," +
                            "\"password\": \"" + this.pwdUserUpd + "\"," +
                            "\"plainPassword\": \"" + this.pwdUserUpd + "\"," +
                            "\"telephone\": \"" + this.telephoneUserUpd + "\"," +
                            "\"systemeClient\": \"" + this.scUserUpd + "\"" +
                            "}"
                    }

                    if (this.nameUserUpd != '') {
                        if (this.emailUserUpd != '') {
                            if (this.scUserUpd != '') {
                                this.$confirm(
                                    {
                                        title: 'Etes vous sûr?',
                                        message: 'Etes vous sur de vouloir modifier ' + this.listUser[key].name + '?',
                                        button: {
                                            yes: 'Oui',
                                            no: 'Non'
                                        },
                                        callback: confirm => {
                                            if (confirm == true) {
                                                fetch(this.racine + this.site + 'api/users/' + this.listUser[key].id, {
                                                    method: 'PUT',
                                                    headers: {
                                                        'Content-Type': 'application/json',
                                                        'Authorization': 'Bearer ' + this.token
                                                    },
                                                    body: bodyUpd
                                                }).then(response => response.json())
                                                    .then(json => {
                                                        console.log(json);
                                                        if (json['@type'] == "hydra:Error") {
                                                            this.errors.push("Ce nom est déjà utilisé.")
                                                            this.popup()
                                                        }
                                                        else if (json['id'] > 0) {
                                                            this.msgs.push("Modification du type effectué.")
                                                            this.getUsers()
                                                            this.nameUser = ''
                                                            this.popup()
                                                            this.keyUpd = null
                                                        }
                                                        else {
                                                            this.errors.push("Un problème inconnu s'est produit.")
                                                            this.popup()
                                                        }
                                                    })
                                            }
                                        }
                                    }
                                )
                            }
                            else {
                                this.errors.push("Vous devez sélectionner le système.");
                            }
                        }
                        else {
                            this.errors.push("Vous devez remplir l'e-mail.");
                        }
                    }
                    else {
                        this.errors.push("Vous devez remplir le nom.");
                    }
                },
                popup() {
                    this.$bvModal.show('modalInfo')
                    setTimeout(() => {//on laisse le message quelques instants
                        this.$bvModal.hide('modalInfo')
                        this.errors = []
                        this.msgs = []
                    }, 2000)
                },
                cancel() {
                    this.keyUpd = null
                },
                deleteObjet(key) {
                    var self = this
                    this.$confirm(
                        {
                            title: 'Etes vous sûr?',
                            message: 'Etes vous sur de vouloir supprimer ' + this.listUser[key].name + '?',
                            button: {
                                yes: 'Oui',
                                no: 'Non'
                            },
                            callback: confirm => {
                                if (confirm == true) {
                                    fetch(this.racine + this.site + 'api/users/' + this.listUser[key].id, {
                                        method: 'DELETE',
                                        headers: {
                                            'Content-Type': 'application/json',
                                            'Authorization': 'Bearer ' + this.token
                                        }
                                    }).then(function (response) {
                                        console.log(response.ok)
                                        if (response.ok == true) {
                                            self.getUsers()
                                            self.keyUpd = null
                                            self.msgs.push("Suppression du type effectuée.")
                                            self.popup()
                                        }
                                        else {
                                            self.errors.push("Un problème inconnu s'est produit.")
                                            self.popup()
                                        }

                                    })
                                }
                            }
                        }
                    )

                },

            },
        mounted() {
            this.getUsers()

        },
        created() {
        },
        components: {
            Aide,
        }
    }
</script>

<style scoped>

</style>